import type { Occurrence, OccurrenceType } from '@lotta/shared/types-lottery-schemas';

/**
 * Formats a lottery into a period string
 * @param occurrence The occurrence of a lottery
 * @returns A formatted string describing the lottery's period
 */
export const getFormattedPeriod = (occurrence: Occurrence) => {
  switch (occurrence.occurrenceType) {
    case 'MONTHLY':
      return 'home-lottery-period';
    case 'WEEKLY':
      return 'home-lottery-period';
    case 'SINGLE':
      return 'home-lottery-period';
    default:
      return 'home-lottery-period-unknown';
  }
};

/**
 * Formats the input into a string describing the type of lottery
 * @param type The type of lottery
 * @returns A key to the correct translation to use
 */
export const getFormattedType = (type: OccurrenceType) => {
  switch (type) {
    case 'MONTHLY':
      return 'home-lottery-type-monthly';
    case 'WEEKLY':
      return 'home-lottery-type-weekly';
    case 'SINGLE':
      return 'home-lottery-type-single';
    default:
      return 'general-unknown';
  }
};
